<app-spinner [size]="64"></app-spinner>
